import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  foods: [],
  food: null,
  error: null
};

const foodSlice = createSlice({
  name: "food",
  initialState,
  reducers: {
    setFoods: (state, action) => {
      state.foods = action.payload;
    },
    setFood: (state, action) => {
      state.food = action.payload;
    },
    addFood: (state, action) => {
      state.foods.push(action.payload);
    },
    updateFood: (state, action) => {
      console.log(action.payload);

      const food = state.foods.find(item => item.id === action.payload.id);
    },
    removeFood: (state, action) => {
      state.foods = state.foods.filter(item => item.id !== action.payload.id);
    }
  },
  selectors: {
    selectFood: state => state.food,
    selectFoods: state => state.foods
  }
});

export const {
  setFood,
  setFoods,
  addFood,
  removeFood,
  updateFood
} = foodSlice.actions;

export const { selectFood, selectFoods } = foodSlice.selectors;

export default foodSlice.reducer;
